import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";

import AuthWrapper from "../AuthWrapper";
import Login from "../../pages/Login";
import { router } from "constants/constans";

const AccountManagement = lazy(() => import("../../pages/AccountManagement"));

// Pages
// const Login = lazy(() => import("../../pages/Login"));
// const SignUp = lazy(() => import('pages/SignUp'));
// const Page404 = lazy(() => import('pages/Page404'));
// const Page500 = lazy(() => import('pages/Page500'));

export default function RootWrapper() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path={router.Manager.AccountManagement}
        element={<AccountManagement />}
      />

      <Route path="/*" element={<AuthWrapper />}></Route>
    </Routes>
  );
}
